import { Provider } from "./product-links";
import styled from "@emotion/styled";
import reactStringReplace from "react-string-replace";
import { trackEvent } from "../tracking/utils";
import { useEffectOnceWithDependencies } from "../hooks/useEffectOnceWithDependencies";
import { useStyleVariant } from "./useStyleVariant";

const S = {
  Card: styled.div`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 12px 14px;
    margin: 12px 0;
  `,
  Label: styled.div`
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.75;
    margin-bottom: 4px;
    color: #fff;
  `,
  CardText: styled.p`
    margin: 0;
    color: #fff;
    line-height: 1.4;
  `,
  CardLink: styled.a`
    color: #fff;
    text-decoration: underline;
  `,
  Plain: styled.p`
    margin: 12px 0;
    color: #fff;
    line-height: 1.4;
  `,
  PlainLink: styled.a`
    color: #fff;
  `,
};

export interface AdData {
  item: string;
  provider: Provider;
  link: string;
  text: string;
  variantIndex: number;
}

interface Props {
  link: AdData;
}

export const AddLink = ({ link }: Props) => {
  const styleVariant = useStyleVariant();

  useEffectOnceWithDependencies(() => {
    trackEvent("Add Link Seen", {
      item: link.item,
      provider: link.provider,
      variantIndex: link.variantIndex,
      styleVariant,
    });
  }, []);

  const handleClick = () => {
    trackEvent("Add Link Clicked", {
      item: link.item,
      provider: link.provider,
      variantIndex: link.variantIndex,
      styleVariant,
    });
  };

  const LinkEl = styleVariant === "card" ? S.CardLink : S.PlainLink;
  const renderedText = reactStringReplace(link.text, /{{(.*?)}}/, (match) => (
    <LinkEl
      onClick={handleClick}
      target="_blank"
      rel="sponsored noopener noreferrer"
      href={link.link}
    >
      {match}
    </LinkEl>
  ));

  if (styleVariant === "card") {
    return (
      <S.Card>
        <S.Label>💡 Weer tip</S.Label>
        <S.CardText>{renderedText}</S.CardText>
      </S.Card>
    );
  }

  return <S.Plain>{renderedText}</S.Plain>;
};
